import React from "react";
import { Container, Row, Col, Input, Button } from "reactstrap";
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
const FooterSection: React.FC = () => (
  <footer className="footer-bg">
    <Container>
      <Row className="footer-main d-flex justify-content-center">
        <Col md="4" className="mb-4" 
        style={{
          marginRight:'56px'
        }}>
          <div className="footer-brand mb-2">WoCons</div>
          <div className="footer-desc mb-3">
            Wocons Private Limited. Bengaluru-based experts in Custom AI Solutions, CAD Design, Automation & Customization. Driving innovation for your business.
          </div>
          <div className="footer-socials">
  <a href="#"><FacebookIcon /></a>
  <a href="#"><XIcon /></a>
  <a href="#"><LinkedInIcon /></a>
  <a href="#"><InstagramIcon /></a>
  <a href="#"><YouTubeIcon /></a>
</div>
        </Col>
        <Col md="2" xs="6" className="mb-4">
          <div className="footer-col-title">Quick Links</div>
          <ul className="footer-list">
            <li><a href="/">Home</a></li>
            <li><a href="#services-section">Services</a></li>
            <li><a href="#success-stories-section">Solutions</a></li>
            <li><a href="#solutions-section">Case Studies</a></li>
            <li><a href="#about-section">About Us</a></li>
            <li><a href="#contact-section">Contact Us</a></li>
          </ul>
        </Col>
        <Col md="3" xs="6" className="mb-4">
          <div className="footer-col-title">Our Services</div>
          <ul className="footer-list">
            <li>CAD Automation & Customization</li>
            <li>Custom AI Development</li>
            <li>Machine Learning Solutions</li>
            <li>Data Analytics & Insights</li>
            <li>Natural Language Processing</li>
            <li>Computer Vision Systems</li>
          </ul>
        </Col>
        {/* <Col md="3" className="mb-4">
          <div className="footer-col-title">Stay Updated</div>
          <div className="footer-subscribe mb-2 d-flex">
            <Input className="footer-sub-input" placeholder="Enter your email" />
            <Button
              className="footer-sub-btn"
              style={{
                background: "linear-gradient(90deg,#4175fc 0%,#9159f4 100%)",
                border: "none"
              }}
            >
              Subscribe
            </Button>
          </div>
          <div className="footer-contact">
            <div><i className="fas fa-map-marker-alt footer-contact-icon"></i> Hosur Main Road, Kudlu Gate, Bangalore, India</div>
            <div><i className="fas fa-phone-alt footer-contact-icon"></i> +91 (XXX) XXX-XXXX</div>
            <div><i className="fas fa-envelope footer-contact-icon"></i> contact@wocons.com</div>
          </div>
        </Col> */}
      </Row>
   {/* <div className="footer-bottom text-center">
  <div>
    © {new Date().getFullYear()} <span className="footer-bold">WoCons</span>. All rights reserved.    Designed & Developed by <span className="footer-bold">WoCons</span>.
  </div>
  <div>

  </div> 
</div> */}

    </Container>
  </footer>
);

export default FooterSection;
